// Grab the current page url path
var path = window.location.pathname;
DomObserver.observe('a', function (links) {
  links.forEach(function (link) {
    try {
      // Start by grabbing the href value from the link
      var href = link.getAttribute('href');
      // Convert the href to a URL
      var url = new URL(href, window.location.origin);
      // Convert the pathname to a string
      var linkpath = url.pathname.toString();

      // Remove section and current classes from all links
      link.classList.remove('section', 'current', 'linking-mode');

      // If the url origin does not match the current origin, return
      if (url.origin != window.location.origin) return;

      // If the current path is /xxx/yyy and the linkpath is /xxx/yyy, add the class 'current'
      // If the current path is /xxx/yyy/zzz and the linkpath is /xxx/yyy, add the class 'section'
      if (path === linkpath) return link.classList.add('current', 'linking-mode');
      if (path.startsWith(linkpath) && linkpath !== "/" && path.charAt(linkpath.length) === '/') {
        return link.classList.add('section', 'linking-mode');
      }
    } catch (error) {
      // If there is an error (e.g. invalid URL), log it and return
      console.warn("Error processing link: ".concat(error));
    }
  });
});